import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

// Custom imports

import loggedInUserInfoSlice from "./Slices/LoggedInUserInfo";
import commonSlice from "./Slices/CommonSlice";

const reducers = combineReducers({
  loggedInUserInfo: loggedInUserInfoSlice.reducer,
  common: commonSlice.reducer,
});

// Reset State of full Application
const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }

  return reducers(state, action);
};

const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default Store;
